import React from 'react';
import { FadeIn } from './FadeIn';
export function ValueStack() {
  return <section className="py-20 sm:py-32 px-4 bg-carbon-900 border-t border-carbon-800" data-id="element-286">
      <div className="max-w-4xl mx-auto" data-id="element-287">
        <FadeIn data-id="element-288">
          <div className="flex items-center gap-4 mb-12" data-id="element-289">
            <span className="font-display text-4xl text-carbon-800" data-id="element-290">05</span>
            <div className="h-px bg-carbon-800 flex-grow" data-id="element-291" />
            <span className="font-mono text-xs text-carbon-400 uppercase tracking-widest" data-id="element-292">
              El Valor Real
            </span>
          </div>

          <h2 className="text-4xl sm:text-6xl font-display text-white mb-16 uppercase tracking-wide text-center" data-id="element-293">
            ¿Cuánto vale todo esto realmente?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-16" data-id="element-294">
          <FadeIn delay={0.1} data-id="element-295">
            <div className="bg-carbon-950 border border-carbon-800 rounded-2xl p-6 sm:p-8 flex gap-6 items-start" data-id="element-296">
              <span className="font-mono text-carbon-500 text-sm mt-1" data-id="element-297">
                [X]
              </span>
              <p className="text-carbon-300 font-sans text-lg" data-id="element-298">
                Podés contratar un coach híbrido que te diseñe un plan de
                temporada personalizado. Son varias horas de consultoría a
                precio de mercado. Solo para el plan inicial.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-299">
            <div className="bg-carbon-950 border border-carbon-800 rounded-2xl p-6 sm:p-8 flex gap-6 items-start" data-id="element-300">
              <span className="font-mono text-carbon-500 text-sm mt-1" data-id="element-301">
                [X]
              </span>
              <p className="text-carbon-300 font-sans text-lg" data-id="element-302">
                Podés comprar cursos separados de fuerza, resistencia, nutrición
                y mentalidad. Cada uno a precio de mercado. Sin integración
                entre ellos. Sin sistema que los conecte.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-303">
            <div className="bg-carbon-950 border border-carbon-800 rounded-2xl p-6 sm:p-8 flex gap-6 items-start" data-id="element-304">
              <span className="font-mono text-carbon-500 text-sm mt-1" data-id="element-305">
                [X]
              </span>
              <p className="text-carbon-300 font-sans text-lg" data-id="element-306">
                Podés seguir probando rutinas de YouTube y planes de Instagram
                hasta encontrar algo que funcione. Más tiempo perdido. Más
                frustración acumulada. Sin garantía de resultado.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-307">
          <div className="border border-electric bg-electric/5 rounded-[2.5rem] p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-308">
            <div className="absolute top-0 left-0 w-full h-1 bg-electric" data-id="element-309" />
            <p className="text-2xl sm:text-3xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-310">
              O podés tener todo eso resuelto, integrado y listo para usar, por
              menos de lo que gastás en un mes de gimnasio.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}